import {Leads, Trails} from '@gwc/main'
import {isReactNode} from '@yandex-delivery/utils'
import {ReactNode, useMemo} from 'react'

import {SlotProps, UpToTwo} from './types'

export const slotFromArray = <T,>(arr: T[] | readonly T[]): undefined | UpToTwo<T> => {
  const filtered = arr.filter(Boolean).slice(0, 2)

  switch (filtered.length) {
    case 0:
      return undefined
    case 1:
      return filtered[0]
    case 2:
      return filtered as UpToTwo<T>
  }
}

const foldUpToTwo = <T, R extends ReactNode>(f: (arg: T) => R, data: undefined | UpToTwo<T>): ReactNode => {
  if (!data) return null

  if (Array.isArray(data)) {
    // Поскольку итемов не больше двух, избегаем необходимости указывать ключ в колбеке
    return (
      <>
        {f(data[0])}
        {f(data[1])}
      </>
    )
  }

  return f(data)
}

export const useSlots = ({lead: leadProp, trail: trailProp}: SlotProps) => {
  const lead = useMemo(
    () =>
      foldUpToTwo(leadItem => {
        if (isReactNode(leadItem)) return <Leads.Icon>{leadItem}</Leads.Icon>

        const {content, type: Lead = Leads.Icon} = leadItem

        if (isReactNode(content)) return <Lead>{content}</Lead>

        return <Lead color={content.color}>{content.icon}</Lead>
      }, leadProp),
    [leadProp],
  )

  const trail = useMemo(
    () =>
      foldUpToTwo(trailItem => {
        if (isReactNode(trailItem)) return <Trails.Icon>{trailItem}</Trails.Icon>

        const {content, type: Trail = Trails.Icon} = trailItem

        if (isReactNode(content)) return <Trail>{content}</Trail>

        return <Trail color={content.color}>{content.icon}</Trail>
      }, trailProp),
    [trailProp],
  )

  return {
    lead,
    trail,
  }
}
